import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import helpers from "@/helpers";

// Carga el conteo de tareas por proyecto (main-dashboard/project-percentage)
// y expone progressFor(project) con el mismo cálculo que Project Details.
export default function useProjectProgress() {
  const store = useStore();
  const taskCounts = ref({});

  onMounted(async () => {
    const response = await store.dispatch("fetchProjectPercentage");
    if (response && Array.isArray(response.data)) {
      const map = {};
      for (const p of response.data) map[p.id_project] = p;
      taskCounts.value = map;
    }
  });

  const progressFor = (project) =>
    helpers.projectProgress(taskCounts.value[project?.id_project]);

  return { progressFor };
}
